import { getEnv } from 'common-nextjs';

/**
 * Google Analytics gtag script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: GoogleAnalyticsScripts.tsx
 */
export function setupGoogleAnalyticsLocalCapture() {
  // @ts-ignore
  if (window.dataLayer && window.gtag) return;

  // @ts-ignore
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    if (getEnv() !== 'production') {
      console.log(
        '[GA Local] gtag called with args:',
        Array.prototype.slice.call(arguments, 0),
      );
    }
    // @ts-ignore
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;
}
